import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import includes from 'lodash/includes'
import isObject from 'lodash/isObject'
import DateTime from 'react-datetime'
import SwitchButton from '../../Components/SwitchButton'
import { currentRole, currentBranch } from '../../Utils/PrivilegeUtils'

class DownloadOrderList extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY'
    this.orderStatus = [
      { value: 'checkout', label: 'CHECKOUT' },
      { value: 'payment-pending', label: 'PENDING' },
      { value: 'payment-failed', label: 'FAILED' },
      { value: 'canceled', label: 'CANCELED' },
      { value: 'confirmed', label: 'CONFIRMED' },
      { value: 'expired', label: 'EXPIRED' },
      { value: 'approved-cs', label: 'APPROVED CS' }
    ]

    this.orderType = [
      { value: 'modem', label: 'MODEM' },
      { value: 'attraction', label: 'ATTRACTION' }
    ]

    this.sourceSelector = [
      { value: '', label: 'ALL' },
      { value: 'ID', label: 'Passpod' },
      { value: 'AP', label: 'Travypass' }
    ]

    this.order_status = [
      { value: 'request-cancel', label: 'REQUEST CANCEL' }
    ]

    this.payment_methods = [
      { value: '', label: '- Select Payment Method -' },
      { value: 'bank-transfer', label: 'BANK TRANSFER' },
      { value: 'credit-card', label: 'CREDIT CARD', restriction: ['PH'] },
      { value: 'cod', label: 'COD', restriction: ['ID'] },
      { value: 'virtual-account', label: 'VIRTUAL ACCOUNT', restriction: ['PH'] },
      { value: 'DANA', label: 'DANA', restriction: ['PH'] },
      { value: 'gopay', label: 'GOPAY', restriction: ['PH'] },
      { value: 'ovo', label: 'OVO', restriction: ['PH'] },
      { value: 'kredivo', label: 'KREDIVO', restriction: ['PH'] },
      { value: 'shopeepay', label: 'SHOPEEPAY', restriction: ['PH'] },
      { value: 'qris', label: 'QRIS', restriction: ['PH'] }
    ].filter((option) => { return (!includes(option.restriction, currentBranch()) && !includes(option.restriction, currentRole())) })

    this.state = {
      filter: {
        from: null,
        until: null,
        code: '',
        status: '',
        order_status: null,
        payment_method: ''
      }
    }
  }

  componentDidMount = () => {
    if (currentRole() === 'admin_travy') {
      this.setState({ filter: { code: 'AP', status: 'confirmed' } })
    }
  }

  _filterChange = (data, field) => {
    const uniq = ['page', 'filterDate', 'from', 'until', 'order_status']
    let val = null
    if (includes(uniq, field)) {
      if (field === 'from' || field === 'until') {
        if (isObject(data)) {
          val = data
        }
      } else {
        val = data
      }
    } else {
      val = data.target.value
    }
    let filter = { ...this.state.filter }
    filter[field] = val
    if (field === 'order_status') {
      filter['status'] = ''
    }
    this.setState({ filter })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = {
      ...this.state.filter
    }

    if (this.state.filter.from && this.state.filter.until) {
      data.from = this.state.filter.from.format('Y-MM-DD')
      data.until = this.state.filter.until.format('Y-MM-DD')
    } else {
      data.from = null
      data.until = null
    }

    this.props.download(data)

    this.props.closeModal()
  }

  render () {
    const { order } = this.props
    const { from } = this.state.filter
    let yesterday = from
    return (
      <form onSubmit={(event) => this._submit(event)} className='section' style={{ width: '20vw' }}>
        <header className='title-block'>
          <h4 className='title mr-auto'>
            Download Order List
            {
              (order.fetching || order.processing) &&
              <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </header>
        <div className='form-group'>
          <label className='control-label mr-2'>Date From</label>
          <DateTime
            value={this.state.filter.from}
            closeOnSelect
            onChange={(date) => this._filterChange(date, 'from')}
            dateFormat='DD/MM/YYYY'
            timeFormat={false}
          />
        </div>
        <div className='form-group'>
          <label className='control-label mr-2'>Date To</label>
          <DateTime
            value={this.state.filter.until}
            closeOnSelect
            onChange={(date) => this._filterChange(date, 'until')}
            dateFormat='DD/MM/YYYY'
            timeFormat={false}
            isValidDate={(current) => current.isAfter(yesterday)}
          />
        </div>
        {
          currentBranch() !== 'PH' &&
          currentRole() !== 'admin_travy' &&
          <div className='form-group'>
            <label className='control-label mr-2'>Source</label>
            <select className='form-control' value={this.state.filter.code} onChange={(event) => this._filterChange(event, 'code')} required>
              <option value='' disabled>-Select Source-</option>
              {
                this.sourceSelector.map((item, i) => (
                  <option key={i} value={item.value}>{item.label}</option>
                ))
              }
            </select>
          </div>
        }
        {
          currentRole() !== 'admin_travy' &&
          <div className='form-group'>
            <label className='control-label mr-2'>Status</label>
            <select disabled={this.state.filter.order_status} className='form-control' value={this.state.filter.status} onChange={(event) => this._filterChange(event, 'status')}>
              <option value=''>All</option>
              {this.orderStatus.map((list, i) => (
                <option key={i} value={list.value}>{list.label}</option>
              ))}
            </select>
          </div>
        }
        <div className='form-group'>
          <label className='control-label mr-2'>Show Request Cancel</label>
          <SwitchButton isChecked={!!this.state.filter.order_status} onChange={() => this._filterChange(!this.state.filter.order_status ? 'request-cancel' : null, 'order_status')} />
        </div>
        <div className='form-group'>
          <label className='control-label mr-2'>Payment Method</label>
          <select className='form-control' value={this.state.filter.payment_method} onChange={(event) => this._filterChange(event, 'payment_method')}>
            {this.payment_methods.map((list, i) => (
              <option key={i} value={list.value}>{list.label}</option>
            ))}
          </select>
        </div>

        <div className='text-right'>
          <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
          <button type='submit' className='btn btn-lg btn-primary'>Download</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  download: filter => dispatch(OrderActions.orderListDownloadRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(DownloadOrderList)



// WEBPACK FOOTER //
// ./src/Containers/Order/DownloadOrderList.js